import(/* webpackMode: "eager" */ "/Users/gokmenkarasu/Desktop/Claude/album-reviews/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/gokmenkarasu/Desktop/Claude/album-reviews/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["MobileVerdictBar"] */ "/Users/gokmenkarasu/Desktop/Claude/album-reviews/src/components/review/MobileVerdictBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReadingProgress"] */ "/Users/gokmenkarasu/Desktop/Claude/album-reviews/src/components/review/ReadingProgress.tsx");
